<div class="border-1 surface-border border-round p-4">
  @if (coverageAmountOptions.length) {
    <em-coverage-card
      i18n-title
      title="Assurance invalidité"
      i18n-tooltipText
      tooltipText="L'âge maximum doit être de {{
        MAX_AGE
      }} ans et la classe de risque pour l'emploi doit être éligible.">
      <p-dropdown
        [options]="coverageAmountOptions"
        [filter]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="30"
        filterBy="value"
        filterMatchMode="startsWith"
        [formControl]="form.controls.coverageAmount"
        optionLabel="name"
        optionValue="value"></p-dropdown>
    </em-coverage-card>
  } @else {
    <em-coverage-card i18n-title title="Assurance invalidité">
      <i i18n>Aucune couverture disponible.</i>
    </em-coverage-card>
  }
  @if (form.controls.coverageAmount.value && products.length) {
    <div class="p-5">
      <h3 class="text-primary mb-2" i18n>Choix du produit</h3>
      <p i18n>Sélectionnez une des options suivantes.</p>
      <p-table
        [value]="products"
        [(selection)]="selectedProduct"
        (onRowSelect)="onSelect($event)"
        [scrollable]="true"
        scrollHeight="500px"
        dataKey="value"
        selectionMode="single">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem"></th>
            <th i18n>Produit</th>
            <th class="text-right" i18n>Prime</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-riderProduct>
          <tr>
            <td>
              <p-tableRadioButton
                [disabled]="riderProduct === selectedProduct"
                [value]="riderProduct"></p-tableRadioButton>
            </td>
            <td>{{ riderProduct.name | emTranslate }}</td>
            @if (!isPriceLoading) {
              <td class="text-right"
                >{{ (riderProduct.price | currency: 'CAD' : 'symbol-narrow' : '1.2-2') || '--' }}
              </td>
            }
            @if (isPriceLoading) {
              <td class="text-right">
                <p-progressSpinner
                  strokeWidth="6"
                  [style]="{width: '100%', height: '15px'}"></p-progressSpinner>
              </td>
            }
          </tr>
        </ng-template>
      </p-table>
    </div>
  }
</div>
